import moment from "moment";
import timeFormAPI from "../api/ui/timeFormAPI";
import {getGrayStateIcon, getGreenStateIcon, getRedStateIcon, getYellowStateIcon} from "../api/ui/icons";

export const POST_NO_TO_STRING = [
    {key: -2, value: '보상금액 없음(0.01 미만)'},
    {key: -1, value: '예산부족으로 지급 불가'},
    {key: 0, value: '발송 지연 중'},
    {key: null, value: '구매 보상 횟수 한도 초과'},
];

// 특정 번호에 매칭하는 문구 출력
export function mailNoToStr(key) {
    const type = POST_NO_TO_STRING?.find(item => item.key === key);
    return type ? type?.value : key;
}

// 우편 타입
export const POST_TYPE = [
    {key: 1, value: '일반 우편'},
    {key: 2, value: '추천 우편'}, // 친구 추천 -> 추천
    {key: 3, value: '스타터 팩 우편'},
    {key: 4, value: 'GEAR 채굴 우편'},
    {key: 5, value: '베이직 모드 우편'},
    {key: 6, value: '래플 이벤트 우편'},
    {key: 7, value: '아이템샵 우편'},
    {key: 8, value: '구글스토어 우편'}
]

export function getPostTypeName(key) {
    const type = POST_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}

export const POST_STATE = {
    Waiting: '발송 대기',
    DepositWaiting: '입금 대기',
    Send: '발송',
    Cancel: '발송 취소',
    Exhausted: '예산 소진'
}

export const getPostState = ({ sentAt, enabled, depositTransactionStatus = 1 }) => {
    if(!enabled) {
        return POST_STATE.Cancel;
    }

    switch (depositTransactionStatus) {
        case 0:
            return POST_STATE.DepositWaiting;
        case 2:
            return POST_STATE.Exhausted;
    }

    const now = moment.utc().format('YYYY-MM-DDTHH:mm:ss.SSS');
    if (timeFormAPI.changeDataLog(sentAt) < now) {
        return POST_STATE.Send;
    }

    return POST_STATE.Waiting;

};

export const getPostStateIcon = ({ sentAt, enabled, depositTransactionStatus }) => {
    const state = getPostState({ sentAt, enabled, depositTransactionStatus });

    switch (state) {
        case POST_STATE.Waiting:
            return getGrayStateIcon(state);
        case POST_STATE.DepositWaiting:
            return getYellowStateIcon(state);
        case POST_STATE.Send:
            return getGreenStateIcon(state);
        case POST_STATE.Cancel:
        case POST_STATE.Exhausted:
            return getRedStateIcon(state);
    }

    return '';
}
